import {
  Annotation,
  AnnotationType,
  ArrowAnnotation,
  CircleAnnotation,
  MoveAnnotationParams,
  PenAnnotation,
  RectangleAnnotation,
  TextAnnotation,
} from '../types';

/** Returns a new annotation shifted by (deltaX, deltaY) in un-rotated original image pixels. */
export const moveAnnotation = ({ annotation, deltaX, deltaY }: MoveAnnotationParams): Annotation => {
  switch (annotation.type) {
    case AnnotationType.Pen:
    case AnnotationType.Highlighter: {
      const pen = annotation as PenAnnotation;
      return {
        ...pen,
        points: pen.points.map((p) => ({ x: p.x + deltaX, y: p.y + deltaY })),
      };
    }
    case AnnotationType.Arrow: {
      const ar = annotation as ArrowAnnotation;
      return {
        ...ar,
        start: { x: ar.start.x + deltaX, y: ar.start.y + deltaY },
        end: { x: ar.end.x + deltaX, y: ar.end.y + deltaY },
      };
    }
    case AnnotationType.Rectangle: {
      const r = annotation as RectangleAnnotation;
      return { ...r, origin: { x: r.origin.x + deltaX, y: r.origin.y + deltaY } };
    }
    case AnnotationType.Circle: {
      const c = annotation as CircleAnnotation;
      return { ...c, center: { x: c.center.x + deltaX, y: c.center.y + deltaY } };
    }
    case AnnotationType.Text: {
      const t = annotation as TextAnnotation;
      return { ...t, position: { x: t.position.x + deltaX, y: t.position.y + deltaY } };
    }
    default:
      return annotation;
  }
};
